/**
 * Toast de error con el mensaje del backend si vino, o el texto traducido del
 * módulo. Auditoría 18/09/2026: `toastError(err, 'common.toast.error_al_guardar')`
 * estaba escrito 91 veces con el fallback en español fijo — quien usa el BO en
 * inglés o portugués veía español justo cuando algo fallaba.
 *
 *   onError: (err) => toastError(err, 'common.toast.error_al_guardar')
 *
 * Usa la instancia de i18n (no el hook) a propósito: casi todos los sitios son
 * `onError` de mutaciones dentro de hooks, fuera del render.
 */
import { toast } from 'sonner';
import i18n from '@/i18n/i18n';

export function toastError(err: unknown, key: string, opts?: Record<string, unknown>): void {
  const msg = (err as { message?: unknown } | null | undefined)?.message;
  toast.error(typeof msg === 'string' && msg.trim() ? msg : i18n.t(key, opts));
}
